import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

type TUserCardDesktopProfileLinkProps = {
  userProfileUrl: string;
};

export const UserCardDesktopProfileLink: React.VFC<TUserCardDesktopProfileLinkProps> = ({ userProfileUrl }) => {
  return (
    <a className={styles['link']} href={userProfileUrl} target="_blank" data-testid="UserCardDesktopProfileLink">
      <UIText1>Перейти в профиль</UIText1>
    </a>
  );
};
